import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start from 23:47:05 as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-bold font-serif text-brand-red" data-id="element-104">
      <div className="flex flex-col items-center" data-id="element-105">
        <span data-id="element-106">{pad(timeLeft.hours)}</span>
        <span className="text-xs md:text-sm text-brand-gray font-sans uppercase tracking-widest mt-1" data-id="element-107">
          hs
        </span>
      </div>
      <span className="pb-6" data-id="element-108">:</span>
      <div className="flex flex-col items-center" data-id="element-109">
        <span data-id="element-110">{pad(timeLeft.minutes)}</span>
        <span className="text-xs md:text-sm text-brand-gray font-sans uppercase tracking-widest mt-1" data-id="element-111">
          min
        </span>
      </div>
      <span className="pb-6" data-id="element-112">:</span>
      <div className="flex flex-col items-center" data-id="element-113">
        <span data-id="element-114">{pad(timeLeft.seconds)}</span>
        <span className="text-xs md:text-sm text-brand-gray font-sans uppercase tracking-widest mt-1" data-id="element-115">
          seg
        </span>
      </div>
    </div>;
}